import { gql } from '@apollo/client'

export default gql`
    fragment WordbookFragment on Wordbook {
        id
        value
        defaults
        values
    }
`
